import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function stopRecurrenceImprovementProposalMeeting(meetingId) {
  if (!meetingId) return false;
  try {
    await getAPIResponse(`/v1/improvement-proposal/meeting/${meetingId}`, { stopRecurrence: true }, 'PATCH');
    return true;
  } catch (e) {
    return false;
  }
}
